import { blue } from "@/utils/Colors";
import { Tooltip as MuiTooltip, TooltipProps } from "@mui/material";

export default function Tooltip(props: Readonly<TooltipProps>) {
  return (
    <MuiTooltip
      title={props.title}
      sx={{ ...props.sx }}
      placement={props.placement ?? "top"}
      slotProps={
        props.slotProps || {
          tooltip: {
            sx: { backgroundColor: blue[100], color: blue[900] },
          },
        }
      }
    >
      {props.children}
    </MuiTooltip>
  );
}
